import $script from 'scriptjs';

import AddToCartFlyout from '../components/AddToCartFlyout';
import ProductQuickshop from './ProductQuickshop';

import { removeTrapFocus, trapFocus } from '#helpers';

export default class ProductGridItem {
  constructor($el) {
    this.$el = $el;
    this.productQuickshop = null;
    this.quickBuySettings = null;
    this.events = [];

    this.$window = $(window);
    this.$html = $('html');
    this.$content = this.$el.find('[data-product-item-content]');
    this.$actions = this.$el.find('[data-product-actions]');
    this.$wishlist = this.$el.find('[data-wishlist-form]');
    this.hasProductActions = this.$actions.length;

    this._addToCart = this._addToCart.bind(this);
    this._openQuickShop = this._openQuickShop.bind(this);

    this._onATCOpen = this._onATCOpen.bind(this);
    this._onATCClose = this._onATCClose.bind(this);

    if (this.hasProductActions) {
      this._setSortByQueryParameters();

      //$scripts checks existence of script in header before attempting to inject
      $script($('[data-scripts]').data('shopify-api-url'), () => {
        this.events.push(
          this.$el.on('click.product-item', '[data-quick-buy]', this._addToCart)
        );
        this.events.push(
          this.$el.on(
            'click.product-item',
            '[data-quickshop-slim]',
            this._openQuickShop
          )
        );
        this.events.push(
          this.$el.on(
            'click.product-item',
            '[data-quickshop-full]',
            this._openQuickShop
          )
        );
      });
    }

    if (this.$el.find('[data-quick-buy]').length) {
      this._initQuickBuy();
    }

    this._objectFitPolyfill();
  }

  /**
   * Make Shopify aware of relevant collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (
        let i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          Shopify.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  _initQuickBuy() {
    try {
      this.quickBuySettings = JSON.parse(
        this.$el.find('[data-quick-buy-settings]').text()
      );
    } catch (error) {
      return console.warn(
        `Quick buy: invalid QuickBuy data found. ${error.message}`
      );
    }
  }

  _openQuickShop(event) {
    event.preventDefault();

    const modalClass = event.currentTarget.hasAttribute('data-quickshop-full')
      ? 'quickshop-full'
      : 'quickshop-slim';

    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }

    this.productQuickshop = new ProductQuickshop({
      $el: this.$el,
      modalClass
    });
  }

  _isObjectFitAvailable() {
    return 'objectFit' in document.documentElement.style;
  }

  _objectFitPolyfill() {
    if (this._isObjectFitAvailable()) {
      return;
    }

    const $image = $('[data-product-item-image]', this.$el);
    const src = $('img', $image).attr('src');

    $image.addClass('product-item-image-no-objectfit');
    $image.css('background-image', `url("${src}")`);
  }

  _addToCart(event) {
    event.preventDefault();
    const $atcButton = $(event.currentTarget);
    const variantID = $atcButton.attr('data-variant-id');
    const sku = $atcButton.attr('data-variant-sku');
    const cdf = $atcButton.attr('data-variant-cdf');
    const consumerUnits = $atcButton.attr('data-variant-consumer-units');

    const formData = [
      {
        name: 'id',
        value: variantID
      },
      {
        name: 'quantity',
        value: 1
      }
    ];

    if (cdf && consumerUnits && sku) {
      formData.push(
        {
          name: 'cdf',
          value: cdf
        },
        {
          name: 'consumer_units',
          value: parseInt(consumerUnits, 10) || 1
        },
        {
          name: 'sku',
          value: sku
        }
      );
    }

    const options = {
      $atcButton,
      settings: {
        moneyFormat: this.quickBuySettings.money_format
      }
    };

    const callbacks = {
      onOpen: this._onATCOpen,
      onClose: this._onATCClose,
      onSuccess: this._onATCSuccess
    };

    AddToCartFlyout.init(formData, options, callbacks);
  }

  /**
   * Callback when AddToCartFlyout opens
   * Move keyboard focus into flyout
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @private
   */
  _onATCOpen(options) {
    trapFocus({
      $container: options.$container,
      $elementToFocus: options.$elementToFocus,
      namespace: 'product-item-flyout'
    });
  }

  /**
   * Callback when AddToCartFlyout closes
   * Move keyboard focus back into grid item
   *
   * @private
   */
  _onATCClose() {
    removeTrapFocus({
      namespace: 'product-item-flyout'
    });

    this.$el.focus();
  }

  _onATCSuccess() {
    if ($(document.body).hasClass('template-cart')) {
      window.location.reload();
    }
  }

  unload() {
    this.events.forEach($el => $el.off('.product-item'));

    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }
  }
}
